module.exports = __webpack_public_path__ + "img/fig02.fc08d2ae.jpg";